import { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, Trash2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";

const src = (url) => (url ? `${process.env.REACT_APP_BACKEND_URL}${url}` : "");
const initials = (name = "") => name.split(" ").map((x) => x[0]).join("").slice(0, 2).toUpperCase();

export function Avatar({ url, name, size = "h-11 w-11", testId }) {
  if (url) return <img src={src(url)} alt={name} className={`${size} shrink-0 rounded-full object-cover border`} data-testid={testId} />;
  return <div className={`${size} shrink-0 rounded-full bg-primary/10 text-primary grid place-items-center font-semibold`} data-testid={testId}>{initials(name)}</div>;
}

export function PhotoUpload({ uid, name, url, onChange }) {
  const [cur, setCur] = useState(url || "");
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post(`/staff/${uid}/photo`, fd);
      setCur(data.photo_url); toast.success("Photo updated"); onChange?.(data.photo_url);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); input.current.value = ""; }
  };
  const remove = () => api.delete(`/staff/${uid}/photo`).then(() => { setCur(""); onChange?.(""); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="flex items-center gap-3" data-testid={`photo-upload-${uid}`}>
      <Avatar url={cur} name={name} size="h-14 w-14" testId={`photo-preview-${uid}`} />
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" data-testid={`photo-input-${uid}`} onChange={(e) => upload(e.target.files[0])} />
      <Button size="sm" variant="outline" className="rounded-full" disabled={busy} data-testid={`photo-btn-${uid}`} onClick={() => input.current.click()}>
        <Camera className="h-4 w-4 mr-1" />{busy ? "Uploading…" : cur ? "Change photo" : "Add photo"}</Button>
      {cur && <Button size="icon" variant="ghost" data-testid={`photo-remove-${uid}`} onClick={remove}><Trash2 className="h-4 w-4" /></Button>}
    </div>
  );
}
